const languageAbbreviation = {
  English: 'en',
  Spanish: 'es',
  Chinese: 'zh',
  French: 'fr',
  Vietnamese: 'vi',
  Japanese: 'ja',
  German: 'de',
  Danish: 'da',
  Dutch: 'nl',
  Portuguese: 'pt',
  Italian: 'it',
  Norwegian: 'no',
  Romanian: 'ro',
  Finnish: 'fi',
  Swedish: 'sv',
  Hungarian: 'hu',
  Czech: 'cs',
  Polish: 'pl',
  Slovak: 'sk',
  Icelandic: 'is',
}

export { languageAbbreviation }
